export const requestUserCameraStream = async () => {
  const attempts = [
    { audio: false, video: { facingMode: { ideal: 'user' }, width: { ideal: 720 }, height: { ideal: 960 } } },
    { audio: false, video: { facingMode: 'user' } },
    { audio: false, video: true },
  ];
  let lastError = null;
  for (const constraints of attempts) {
    try {
      return await navigator.mediaDevices.getUserMedia(constraints);
    } catch (err) {
      lastError = err;
      if (err?.name === 'NotAllowedError' || err?.name === 'PermissionDeniedError') break;
    }
  }
  throw lastError || new Error('Nao foi possivel abrir a camera.');
};

export const waitForVideoElement = (videoRef, timeoutMs = 3000) => new Promise((resolve, reject) => {
  const deadline = Date.now() + timeoutMs;
  const check = () => {
    if (videoRef.current) return resolve(videoRef.current);
    if (Date.now() >= deadline) return reject(new Error('A camera ainda esta inicializando. Tente novamente.'));
    requestAnimationFrame(check);
  };
  check();
});

export const attachStreamToVideo = async (video, stream) => {
  if (!video || !stream) throw new Error('A camera ainda esta inicializando. Tente novamente.');
  video.srcObject = stream;
  video.muted = true;
  video.playsInline = true;
  video.setAttribute('playsinline', 'true');
  video.setAttribute('webkit-playsinline', 'true');
  await video.play();
  if (video.readyState >= 2 && video.videoWidth > 0 && video.videoHeight > 0) return;
  await new Promise((resolve, reject) => {
    const cleanup = () => {
      clearTimeout(timer);
      video.removeEventListener('loadeddata', ready);
      video.removeEventListener('resize', ready);
    };
    const ready = () => {
      if (video.readyState >= 2 && video.videoWidth > 0 && video.videoHeight > 0) {
        cleanup();
        resolve();
      }
    };
    const timer = setTimeout(() => {
      cleanup();
      reject(new Error('A camera ainda esta inicializando. Tente novamente.'));
    }, 5000);
    video.addEventListener('loadeddata', ready);
    video.addEventListener('resize', ready);
    ready();
  });
};

export const captureVideoFrame = async (video) => {
  if (!video || video.readyState < 2 || video.videoWidth <= 0 || video.videoHeight <= 0) {
    throw new Error('A camera ainda esta inicializando. Tente novamente.');
  }
  const canvas = document.createElement('canvas');
  const ratio = Math.min(1, 720 / video.videoWidth);
  canvas.width = Math.max(1, Math.round(video.videoWidth * ratio));
  canvas.height = Math.max(1, Math.round(video.videoHeight * ratio));
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Nao foi possivel capturar a imagem. Tente novamente.');
  try {
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  } catch (_) {
    throw new Error('Nao foi possivel capturar a imagem. Tente novamente.');
  }
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.86));
  if (!blob || blob.size < 1024) throw new Error('Nao foi possivel capturar a imagem. Tente novamente.');
  return blob;
};
